import { createTheme, } from '@mui/material';
import { yellow, cyan, green, orange, } from '@mui/material/colors';

export const DarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: yellow[700],
            dark: yellow[800],
            light: yellow[500],
            contrastText: '#000000',
        },
        secondary: {
            main: '#000000',
            dark: cyan[400],
            light: cyan[300],
            contrastText: '#ffffff',
        },
        success: {
            main: '#4caf50',
            dark: '#2e7d32',
            light: '#4caf50',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#ed6c02',
            dark: '#e65100',
            light: '#ff9800',
            contrastText: '#ffffff',
        },
        background: {
            paper: '#303134',
            default: '#202124'
        },
    },
    typography: {
        allVariants: {
            color: 'white',
        },
        button: {
            color: 'black',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: 'black',
                    '&.Mui-disabled': {
                        color: 'grey',
                    },
                }
            },
        },
    }

});